export const SET_USER = 'setUser';
export const LOADING = 'setLoading';

export const SET_ENTIDADE = 'setEntidade';
